import { render } from "./MyOldNewslettersStatistics.vue?vue&type=template&id=5ca4b102"
import script from "./MyOldNewslettersStatistics.vue?vue&type=script&lang=ts"
export * from "./MyOldNewslettersStatistics.vue?vue&type=script&lang=ts"

import "./MyOldNewslettersStatistics.vue?vue&type=style&index=0&id=5ca4b102&lang=scss"
script.render = render

export default script